var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCcs2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b,.g{fill:#71778a;}.c{fill:#cad0e4;}.d{fill:#353841;}.e,.g{stroke:none;}.f{fill:none;}.h{filter:url(#q);}.i{filter:url(#o);}.j{filter:url(#m);}.k{filter:url(#k);}.l{filter:url(#i);}.m{filter:url(#g);}.n{filter:url(#e);}.o{filter:url(#c);}.p{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 35.186,
    y: 27.309,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 18,
    y: 47.031,
    width: 18.997,
    height: 18.997,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 37,
    y: 47.031,
    width: 18.997,
    height: 18.997,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 22.701,
    y: 27.309,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 41.428,
    y: 17.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 28.944,
    y: 17.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 16.459,
    y: 17.5,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 23.593,
    y: 9.474,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "q",
    x: 36.078,
    y: 9.474,
    width: 14,
    height: 14,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "r"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "r"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-243 -576)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H24V10H0Z",
    transform: "translate(268 616.227)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-6326-3134.437a21.225,21.225,0,0,1-14.849-5.949,19.851,19.851,0,0,1-6.15-14.364,19.562,19.562,0,0,1,2.286-9.227A20.7,20.7,0,0,1-6338.6-3171h25.2a20.692,20.692,0,0,1,6.111,7.023,19.584,19.584,0,0,1,2.288,9.227,19.858,19.858,0,0,1-6.151,14.364A21.225,21.225,0,0,1-6326-3134.437Z",
    transform: "translate(6606 3756.016)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "p",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(38.19 30.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 36,
    height: 17,
    rx: 8.5,
    transform: "translate(262 624)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(21 50.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 6.498535633087158 11.9970760345459 C 3.466625690460205 11.9970760345459 0.9999956488609314 9.53044605255127 0.9999956488609314 6.498535633087158 C 0.9999956488609314 3.466625690460205 3.466625690460205 0.9999956488609314 6.498535633087158 0.9999956488609314 C 9.53044605255127 0.9999956488609314 11.9970760345459 3.466625690460205 11.9970760345459 6.498535633087158 C 11.9970760345459 9.53044605255127 9.53044605255127 11.9970760345459 6.498535633087158 11.9970760345459 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 6.498535633087158 1.999995231628418 C 4.018035888671875 1.999995231628418 1.999995231628418 4.018035888671875 1.999995231628418 6.498535633087158 C 1.999995231628418 8.979036331176758 4.018035888671875 10.9970760345459 6.498535633087158 10.9970760345459 C 8.979036331176758 10.9970760345459 10.9970760345459 8.979036331176758 10.9970760345459 6.498535633087158 C 10.9970760345459 4.018035888671875 8.979036331176758 1.999995231628418 6.498535633087158 1.999995231628418 M 6.498535633087158 -4.76837158203125e-06 C 10.08757591247559 -4.76837158203125e-06 12.9970760345459 2.90949535369873 12.9970760345459 6.498535633087158 C 12.9970760345459 10.08757591247559 10.08757591247559 12.9970760345459 6.498535633087158 12.9970760345459 C 2.90949535369873 12.9970760345459 -4.76837158203125e-06 10.08757591247559 -4.76837158203125e-06 6.498535633087158 C -4.76837158203125e-06 2.90949535369873 2.90949535369873 -4.76837158203125e-06 6.498535633087158 -4.76837158203125e-06 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(40 50.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 6.498535633087158 11.9970760345459 C 3.466625690460205 11.9970760345459 0.9999956488609314 9.53044605255127 0.9999956488609314 6.498535633087158 C 0.9999956488609314 3.466625690460205 3.466625690460205 0.9999956488609314 6.498535633087158 0.9999956488609314 C 9.53044605255127 0.9999956488609314 11.9970760345459 3.466625690460205 11.9970760345459 6.498535633087158 C 11.9970760345459 9.53044605255127 9.53044605255127 11.9970760345459 6.498535633087158 11.9970760345459 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 6.498535633087158 1.999995231628418 C 4.018035888671875 1.999995231628418 1.999995231628418 4.018035888671875 1.999995231628418 6.498535633087158 C 1.999995231628418 8.979036331176758 4.018035888671875 10.9970760345459 6.498535633087158 10.9970760345459 C 8.979036331176758 10.9970760345459 10.9970760345459 8.979036331176758 10.9970760345459 6.498535633087158 C 10.9970760345459 4.018035888671875 8.979036331176758 1.999995231628418 6.498535633087158 1.999995231628418 M 6.498535633087158 -4.76837158203125e-06 C 10.08757591247559 -4.76837158203125e-06 12.9970760345459 2.90949535369873 12.9970760345459 6.498535633087158 C 12.9970760345459 10.08757591247559 10.08757591247559 12.9970760345459 6.498535633087158 12.9970760345459 C 2.90949535369873 12.9970760345459 -4.76837158203125e-06 10.08757591247559 -4.76837158203125e-06 6.498535633087158 C -4.76837158203125e-06 2.90949535369873 2.90949535369873 -4.76837158203125e-06 6.498535633087158 -4.76837158203125e-06 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(25.7 30.31)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(44.43 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(31.94 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(19.46 20.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9.25 C 2.656539916992188 9.25 0.75 7.343460083007813 0.75 5 C 0.75 2.656539916992188 2.656539916992188 0.75 5 0.75 C 7.343460083007813 0.75 9.25 2.656539916992188 9.25 5 C 9.25 7.343460083007813 7.343460083007813 9.25 5 9.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 1.5 C 3.070089817047119 1.5 1.5 3.070089817047119 1.5 5 C 1.5 6.929909706115723 3.070089817047119 8.5 5 8.5 C 6.929909706115723 8.5 8.5 6.929909706115723 8.5 5 C 8.5 3.070089817047119 6.929909706115723 1.5 5 1.5 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(26.59 12.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 243, 576)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(39.08 12.47)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 4 7.25 C 2.207940101623535 7.25 0.75 5.792059898376465 0.75 4 C 0.75 2.207940101623535 2.207940101623535 0.75 4 0.75 C 5.792059898376465 0.75 7.25 2.207940101623535 7.25 4 C 7.25 5.792059898376465 5.792059898376465 7.25 4 7.25 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 4 1.5 C 2.621500015258789 1.5 1.5 2.621500015258789 1.5 4 C 1.5 5.378499984741211 2.621500015258789 6.5 4 6.5 C 5.378499984741211 6.5 6.5 5.378499984741211 6.5 4 C 6.5 2.621500015258789 5.378499984741211 1.5 4 1.5 M 4 0 C 6.209139823913574 0 8 1.790860176086426 8 4 C 8 6.209139823913574 6.209139823913574 8 4 8 C 1.790860176086426 8 0 6.209139823913574 0 4 C 0 1.790860176086426 1.790860176086426 0 4 0 Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCcs2);
export default __webpack_public_path__ + "static/media/ccs2.fb46f0d8c1ba91573d2bc979c615a97e.svg";
export { ForwardRef as ReactComponent };